module.exports = __webpack_public_path__ + "img/scenarios3.33a35085.png";